import { render, staticRenderFns } from "./waterQualityAlarmNowScrollList.vue?vue&type=template&id=16f2073c&scoped=true"
import script from "./waterQualityAlarmNowScrollList.vue?vue&type=script&lang=js"
export * from "./waterQualityAlarmNowScrollList.vue?vue&type=script&lang=js"
import style0 from "./waterQualityAlarmNowScrollList.vue?vue&type=style&index=0&id=16f2073c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f2073c",
  null
  
)

export default component.exports